/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_List_AriaInputs */

const en_directory_builders_list_aria = /** @type {(inputs: Directory_Builders_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder directory`)
};

const zh_directory_builders_list_aria = /** @type {(inputs: Directory_Builders_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创作者目录`)
};

/**
* | output |
* | --- |
* | "Builder directory" |
*
* @param {Directory_Builders_List_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_list_aria = /** @type {((inputs?: Directory_Builders_List_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_List_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_list_aria(inputs)
	return zh_directory_builders_list_aria(inputs)
});
export { directory_builders_list_aria as "directory.builders.list_aria" }